import React, {Component} from 'react';
import TimeGrid, { TimeGridItem } from '../TimeGrid';
import moment from 'moment';
import AppCalendarCell from '../Appointments/AppCalendarCell';
import { AppointmentService } from '../../api/Service';
export default class SettingsHoursView extends TimeGrid{


    get colSegs(){
        return 1;
    }

    getClassNames(){
        return 'settings-hours-view';
    }

    getColumnHeaders(){
        let weekRange = moment(this.props.date);
        let today = moment().format('YYYY/M/D');
        let days = [];
        let cs = this.props.timeData;

        for(let i=0; i < 7; i++){
            weekRange.day(i)
            let isToday = (today == weekRange.format('YYYY/M/D'));
            days.push(<ColumnHeader key={i} column={i} enabled={cs[i]} className={'column-header ' + (isToday ? "today" : "") + (cs[i]? ' enabled' : '')} onStateChange={this.setColumnState}>{weekRange.format(this.props.headerFormat || "ddd MMM D")}</ColumnHeader>);
        }

        return days;
    }

    setColumnState = (col, state) => {
        this.props.onDayStateToggle(col, state );
    }

    __handleGridItemDrop = (item, bounds, itemId, eventName, layer, touchEvent) => {
        //console.log('Item Dropped:', layer, item, bounds)
        const cell = item.item;
        if(this.props.onTimeChange){
            const pos = {
                x: bounds[0],
                y: bounds[1],
                w: bounds[2],
                h: bounds[3]
            }



            let start = this.getTimeFromRow(pos.y);
            let end = this.getTimeFromRow(pos.y + pos.h);

            this.props.onTimeChange(cell.props.day, [start.format('H:mm'), end.format('H:mm')]);

        }
    }

    getItems(){
       // console.log('getItems Date:', moment(this.props.date).format('YYYY/M/D'));
        //let apps = this.props.appointments.filter( app => moment(app.start).format('YYYY/M/D') == moment(this.props.date).format('YYYY/M/D'));
        let items = {};

        for(let i=0; i < 7; i++){
            let timeData = this.props.timeData[i];

            if(timeData){
                let timeStart = moment(timeData[0], 'H:mm');
                let timeEnd = moment(timeData[1], 'H:mm');
                let rowStart = this.getRowFromTime(timeStart);
                let rowEnd = this.getRowFromTime(timeEnd);

                let gridData = this.newGridData();

                gridData.x = i;//this.getItemCol(app);
                gridData.y = rowStart;
                gridData.h = rowEnd - rowStart;

                items[i] = {
                    item: <ScheduleTimeCell  id={gridData.i} grid={this} timeStart={timeStart} timeEnd={timeEnd} day={i} onTimeChange={this.props.onTimeChange} />,
                    bounds: [gridData.x, gridData.y, gridData.w, gridData.h],
                    allowResize: true,
                    draggable: true
                }

                /*items.push(
                    <div key={gridData.i} data-grid={gridData}>
                        <ScheduleTimeCell  id={gridData.i} grid={this} timeStart={timeStart} timeEnd={timeEnd} day={i} onTimeChange={this.props.onTimeChange} />
                    </div>
                )*/
            }else{
                let timeStart = moment(this.props.startTime, 'H:mm');
                let timeEnd = moment(this.props.endTime, 'H:mm');
                let rowStart = this.getRowFromTime(timeStart);
                let rowEnd = this.getRowFromTime(timeEnd);

                let gridData = this.newGridData();

                gridData.x = i;//this.getItemCol(app);
                gridData.y = rowStart;
                gridData.h = rowEnd - rowStart;
                gridData.static = true;

                items[i] = {
                    item: <div key={gridData.i} data-grid={gridData}></div>,
                    bounds: [gridData.x, gridData.y, gridData.w, gridData.h],
                    allowResize: true,
                    draggable: true
                }

                /*items.push(
                    <div key={gridData.i} data-grid={gridData}></div>
                )*/
            }


        }

        return items;
    }

    hiddenStuff(){
        let styles = [];
        let cs = this.props.timeData;
        for(let i=0; i < cs.length; i++){
            if(cs[i]){
                styles.push(`.settings-hours-view .calendar-grid [col="` + i +`"]{
                    background-color: #FBFBFB;;
                }`);
            }
        }
        return <style dangerouslySetInnerHTML={ {__html: styles.join("\n")}} />
    }
}



export class ScheduleTimeCell extends TimeGridItem{
    constructor(props){
        super(props);
        this.state = {
            timeStart: this.props.timeStart || moment('9', 'h:m'),
            timeEnd: this.props.timeEnd || moment('18', 'h')
        }
        this.grid = this.props.grid;
        console.log('ScheduleTimeCell Construct')
    }

    formatTime(time){
        let format =  'h:mm a';
        if(time.minute() == 0){
            format = 'h a';
        }
        return time.format(format);
    }

    onMove(pos){
        let start = this.grid.getTimeFromRow(pos.y);
        let end = this.grid.getTimeFromRow(pos.y + pos.h)
        this.setState({timeStart:start, timeEnd:end});
        console.log('SettingsHoursView onMove:', pos)
    }

    onDrop(pos){
        let start = this.grid.getTimeFromRow(pos.y);
        let end = this.grid.getTimeFromRow(pos.y + pos.h);
        this.setState({timeStart:start, timeEnd:end});
        if(this.props.onTimeChange){
            this.props.onTimeChange(this.props.day, [start.format('H:mm'), end.format('H:mm')]);
        }
        console.log('SettingsHoursView:', pos)
    }

    render(){
        let time = this.formatTime(this.props.timeStart) + " - " + this.formatTime(this.props.timeEnd);
        return(
            <div key={this.__id} class='schedule-time-cell'>
                <div>{time}</div>
            </div>
        )
    }
}

class ColumnHeader extends Component{
    toggleState(){
        if(this.props.onStateChange){
            this.props.onStateChange(this.props.column, !this.props.enabled);
        }
    }

    render(){
        let {children, enabled, ...props} = this.props;
        return(
            <div className={props.className} title='Toggle Day On / Off' onClick={()=> {this.toggleState();}}><span>{children}</span></div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Settings/SettingsHoursView.js